import {
    USER_DETAIL,
    USER_DETAIL_SUCCESS,
    USER_DETAIL_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    actions: {
        data: {actions: 0, user:{iduser_type: 2}},
        loading: true,
        message: ''
    },
    detail: {
        data: [],
        tab: '1',
        loading: true,
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case USER_DETAIL:
            return {
                ...state,
                detail: {
                ...state.detail,
                loading: true,
                data: []
                }
            }
        case USER_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                detail: {
                    ...state.detail,
                    loading: false,
                    ...action.payload
                }
            }
        case USER_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                detail: {
                ...state.detail,
                loading: false,
                data: []
                }
            }

        default:
            return { ...state };
    }
};